import { z } from "zod";

const safeUrl = z
	.url({ message: "Please enter a valid URL" })
	.refine((value) => !/^javascript:/i.test(value) && !/^data:/i.test(value), { message: "Invalid URL scheme" });

export const createCommunityLinkSchema = z
	.object({
		title: z.string().trim().min(1, { message: "Title is required" }).max(80, { message: "Title must be at most 80 characters" }),
		url: safeUrl,
	})
	.strict();

export type CreateCommunityLinkPayload = z.infer<typeof createCommunityLinkSchema>;
